import {Vue} from 'nuxt-property-decorator';
import CookieLaw from 'vue-cookie-law';

Vue.component('cookie-law', CookieLaw);
